import { ResponseTransformer } from '../ResponseTransformer';
import * as http from '~/utils/apis';
export const API_PREFIX = 'cms-api/item-saga/consumables';
import { camelizeKeys, titleCase } from '~/utils/helpers';

const consumableApi = {
    index: async () => {
        const { data } = await http.get(`${API_PREFIX}`);

        return camelizeKeys(data);
    },

    create: async () => {
        let { data } = await http.get(`${API_PREFIX}/create`);

        data = new ResponseTransformer(data);
        data.camelizeKeys();
        data.transformRarities();

        return data;
    },

    store: async (body) => {
        await http.post(`${API_PREFIX}`, body, {});
    },

    show: async (id) => {
        let { data } = await http.get(`${API_PREFIX}/${id}`);

        data = new ResponseTransformer(data);
        data.camelizeKeys();
        data.transformRarities();

        return data;
    },

    update: async (id, body) => {
        await http.put(`${API_PREFIX}/${id}`, body, {});
    },

    delete: async (id) => {
        await http.destroy(`${API_PREFIX}/${id}`);
    },
};

const transformRarities = {
    transformRarities() {
        this.data.rarities.forEach(function (rarity, i, arr) {
            arr[i] = {
                id: rarity,
                name: titleCase(rarity),
            };
        });
    },
};
Object.assign(ResponseTransformer.prototype, transformRarities);

export default consumableApi;
